<template>
  <div class="left">
    <h1 class="left-item">
      {{ this.title }}
    </h1>
    <h1 class="left-item1">
      {{ this.introduce }}
    </h1>
    <div class="left-item2">
      <div
        class="left-change"
        v-for="(item, index) in list"
        :key="index"
        :class="setClass(item.ordina)"
        @click="change(item.ordina)"
      >
        <div class="left-item3">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "informLeft",
  props: {
    left: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      left1: this.left,
      ind: 204 || 301,
      rootId: "",
      list: [],
      title: "",
      introduce: "",
      onceShow: true
    };
  },
  watch: {
    left: {
      handler: function(to, from) {
        this.ind = this.$route.query.tagnum;
        this.title = this.left.title;
        this.list = this.left.list;
        this.introduce = this.left.introduce;
      },
      deep: true
    }
  },
  mounted() {
    this.ind = this.$route.query.tagnum;
    this.title = this.left.title;
    this.list = this.left.list;
    this.introduce = this.left.introduce;
  },
  methods: {
    //修改颜色
    setClass(index) {
      if (index == this.ind) {
        return "dx";
      } else {
        return "ds";
      }
    },
    // 选择不同的产品介绍类型
    change(index) {
      this.$router.push({
        path: this.$route.path,
        query: {
          tagnum: index
        }
      });
    },
    sortby(prop, rev = true) {
      return function(a, b) {
        var val1 = a[prop];
        var val2 = b[prop];
        return rev ? val1 - val2 : val2 - val1;
      };
    },
    getNav() {
      // let that = this;
      return new Promise((resolve, reject) => {
        // let that = this;
        const info = this.cmsInfo1;
        console.log("info:", info);
        // let cmsInfo = info ? JSON.parse(info) : {};
        this.ind = info.nav;
        this.rootId = info.rootId;
        GMS.$http
          .get("/home/getNavigation")
          .then(res => {
            if (res.status != 200) {
              // TODO 给出异常提示
              // this.$Message.error("获取数据异常，请联系管理员");
              return;
            }
            let data = res.data;
            let currentGroup = data.find(el => el.id == this.rootId);
            if (!currentGroup) {
              this.list = [];
              console.error("未获取到指定的导航分组信息");
              return;
            }
            currentGroup.childList = data.filter(
              item => item.parent == currentGroup.id
            );
            currentGroup.childList.sort(this.sortby("ordina"));
            this.title = currentGroup.title;
            this.list = currentGroup.childList;
            this.introduce = currentGroup.shortName;
            resolve();
          })
          .catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
            console.error(`获取解析导航栏信息异常：${error}`);
          });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.left-change {
  width: 242px;
  height: 40px;
  margin-bottom: 20px;
}
.left {
  height: 687px;
  width: 242px;
  float: left;
  border-right: 1px solid #f3f3f3;
}
.dx {
  cursor: pointer;
  background-color: #f3f3f3;
  color: #015293 !important;
}
.ds {
  cursor: pointer;
  color: #7f7f7f;
  background-color: #ffffff;
}
.left-item {
  color: #424242;
  font-size: 30px;
  width: 120px;
  height: 42px;
  font-family: "PingFangSC";
  font-weight: 600;
}
.left-item1 {
  margin-top: 2px;
  width: 64px;
  height: 24px;
  color: #b8b8b8;
  font-size: 16px;
  font-family: SourceHanSansCN;
  font-weight: 400;
}
.left-item2 {
  width: 242px;
  margin-top: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 81px);
}
.left-item3 {
  padding: 9px 0px 9px 16px;
  height: 22px;
  font-size: 16;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/inside/informLeft.vue